import React from 'react';
import { FormattedMessage } from 'react-intl';
import type { AssetType as AssetTypeEnum, FuelType as FuelTypeEnum } from './types';

import Rioglyph, { type IconType } from '@rio-cloud/rio-uikit/Rioglyph';
import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { type FuelType, getFuelIcon } from '@rio-cloud/rio-uikit/fuelTypeUtils';
import classNames from 'classnames';

interface AssetTypeProps {
    assetType: AssetTypeEnum;
    fuelType?: FuelTypeEnum | null;
    className?: string;
}

const AssetType = React.memo((props: AssetTypeProps) => {
    const fuelTypeIcon = props.fuelType ? getFuelIcon(props.fuelType.toLowerCase() as FuelType) : undefined;

    return (
        <span className={classNames('display-flex', props.className)}>
            <SimpleTooltip
                placement='right'
                content={
                    <>
                        {props.fuelType && (
                            <>
                                <FormattedMessage
                                    id={`assets.masterdata.fuel-type.${props.fuelType.toLowerCase()}`}
                                />{' '}
                            </>
                        )}

                        <FormattedMessage id={`assets.assets.asset.type.${props.assetType.toLowerCase()}`} />
                    </>
                }
            >
                <span>
                    <Rioglyph
                        size='h1'
                        icon={`rioglyph-${props.assetType.toLowerCase()}` as IconType}
                        pairIcon={fuelTypeIcon}
                        pairIconClassName={props.className ?? 'text-color-dark'}
                    />
                </span>
            </SimpleTooltip>
            <span hidden>
                <FormattedMessage id={`assets.assets.asset.type.${props.assetType.toLowerCase()}`} />
            </span>
        </span>
    );
});

export default AssetType;
